import { render } from "./LwSectionTabs.vue?vue&type=template&id=77991715&scoped=true"
import script from "./LwSectionTabs.vue?vue&type=script&lang=js"
export * from "./LwSectionTabs.vue?vue&type=script&lang=js"

import "./LwSectionTabs.vue?vue&type=style&index=0&id=77991715&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77991715"]])

export default __exports__